import {
  Zap, Clock, Mail, MessageSquare, Phone, FileText,
  CheckSquare, UserPlus, Tag, Bell, Calendar, Play,
  Pause, Square, GitBranch, Repeat, Send, Save,
  Bot, ArrowRight, AlertCircle, PhoneMissed, Receipt,
  Star, Shield, Users, Timer, BranchIcon, MessageCircle
} from 'lucide-react';

// Trigger type configurations
export const TRIGGER_TYPES = {
  // Time-based
  scheduled: { label: 'Scheduled', icon: Clock, category: 'time', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' },
  delay: { label: 'After Delay', icon: Timer, category: 'time', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' },
  recurring: { label: 'Recurring', icon: Repeat, category: 'time', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' },
  
  // Job events
  job_created: { label: 'Job Created', icon: FileText, category: 'job', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
  job_updated: { label: 'Job Updated', icon: FileText, category: 'job', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
  job_stage_changed: { label: 'Stage Changed', icon: ArrowRight, category: 'job', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
  job_completed: { label: 'Job Completed', icon: CheckSquare, category: 'job', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
  
  // Task events
  task_created: { label: 'Task Created', icon: CheckSquare, category: 'task', color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400' },
  task_completed: { label: 'Task Completed', icon: CheckSquare, category: 'task', color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400' },
  task_overdue: { label: 'Task Overdue', icon: AlertCircle, category: 'task', color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400' },
  
  // Communications
  call_received: { label: 'Call Received', icon: Phone, category: 'comm', color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400' },
  call_missed: { label: 'Call Missed', icon: PhoneMissed, category: 'comm', color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400' },
  sms_received: { label: 'SMS Received', icon: MessageSquare, category: 'comm', color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400' },
  email_received: { label: 'Email Received', icon: Mail, category: 'comm', color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400' },
  
  // Conversational
  keyword_detected: { label: 'Keyword Detected', icon: MessageCircle, category: 'conversation', color: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400' },
  no_response: { label: 'No Response', icon: Clock, category: 'conversation', color: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400' },
  
  // Estimates/Invoices
  estimate_sent: { label: 'Estimate Sent', icon: FileText, category: 'finance', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
  estimate_signed: { label: 'Estimate Signed', icon: FileText, category: 'finance', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
  invoice_created: { label: 'Invoice Created', icon: Receipt, category: 'finance', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
  invoice_paid: { label: 'Invoice Paid', icon: Receipt, category: 'finance', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
  invoice_overdue: { label: 'Invoice Overdue', icon: AlertCircle, category: 'finance', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
};

// Action type configurations
export const ACTION_TYPES = {
  // Communication
  send_sms: { label: 'Send SMS', icon: MessageSquare, category: 'comm', color: 'bg-blue-100 text-blue-700' },
  send_email: { label: 'Send Email', icon: Mail, category: 'comm', color: 'bg-blue-100 text-blue-700' },
  send_message: { label: 'Send Message', icon: Send, category: 'comm', color: 'bg-blue-100 text-blue-700' },
  send_notification: { label: 'Send Notification', icon: Bell, category: 'comm', color: 'bg-blue-100 text-blue-700' },
  
  // Task actions
  create_task: { label: 'Create Task', icon: CheckSquare, category: 'task', color: 'bg-purple-100 text-purple-700' },
  update_task: { label: 'Update Task', icon: CheckSquare, category: 'task', color: 'bg-purple-100 text-purple-700' },
  assign_task: { label: 'Assign Task', icon: UserPlus, category: 'task', color: 'bg-purple-100 text-purple-700' },
  
  // Job actions
  change_workflow_stage: { label: 'Change Stage', icon: ArrowRight, category: 'job', color: 'bg-green-100 text-green-700' },
  update_job: { label: 'Update Job', icon: FileText, category: 'job', color: 'bg-green-100 text-green-700' },
  add_tag: { label: 'Add Tag', icon: Tag, category: 'data', color: 'bg-yellow-100 text-yellow-700' },
  add_note: { label: 'Add Note', icon: FileText, category: 'data', color: 'bg-yellow-100 text-yellow-700' },
  
  // Conversational
  wait_for_reply: { label: 'Wait for Reply', icon: Clock, category: 'conversation', color: 'bg-cyan-100 text-cyan-700' },
  save_reply_to_field: { label: 'Save Reply', icon: Save, category: 'conversation', color: 'bg-cyan-100 text-cyan-700' },
  branch_on_reply: { label: 'Branch on Reply', icon: GitBranch, category: 'conversation', color: 'bg-cyan-100 text-cyan-700' },
  assign_to_human: { label: 'Assign to Human', icon: Users, category: 'conversation', color: 'bg-cyan-100 text-cyan-700' },
  
  // Flow control
  delay: { label: 'Delay', icon: Timer, category: 'flow', color: 'bg-slate-100 text-slate-700' },
  pause_automation: { label: 'Pause', icon: Pause, category: 'flow', color: 'bg-slate-100 text-slate-700' },
  stop_automation: { label: 'Stop', icon: Square, category: 'flow', color: 'bg-slate-100 text-slate-700' },
  trigger_automation: { label: 'Trigger Another', icon: Zap, category: 'flow', color: 'bg-slate-100 text-slate-700' },
  
  // AI
  ai_generate_summary: { label: 'AI Summary', icon: Bot, category: 'ai', color: 'bg-indigo-100 text-indigo-700' },
  ai_draft_message: { label: 'AI Draft', icon: Bot, category: 'ai', color: 'bg-indigo-100 text-indigo-700' },
  
  // Calendar
  create_calendar_event: { label: 'Create Event', icon: Calendar, category: 'calendar', color: 'bg-red-100 text-red-700' },
};

// Automation categories
export const AUTOMATION_CATEGORIES = [
  { id: 'sales', label: 'Sales', icon: '💰', color: 'bg-green-500' },
  { id: 'operations', label: 'Operations', icon: '⚙️', color: 'bg-blue-500' },
  { id: 'support', label: 'Support', icon: '🎧', color: 'bg-purple-500' },
  { id: 'finance', label: 'Finance', icon: '💳', color: 'bg-emerald-500' },
  { id: 'marketing', label: 'Marketing', icon: '📢', color: 'bg-orange-500' },
];

// Automation types
export const AUTOMATION_TYPES = [
  { id: 'standard', label: 'Standard', description: 'Simple trigger-action automation' },
  { id: 'conversational', label: 'Conversational', description: 'Interactive message flows' },
  { id: 'sequence', label: 'Sequence', description: 'Multi-step drip campaigns' },
];

// Status configurations
export const AUTOMATION_STATUSES = {
  draft: { label: 'Draft', color: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300' },
  active: { label: 'Active', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
  paused: { label: 'Paused', color: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400' },
  archived: { label: 'Archived', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' },
};

// Execution statuses
export const EXECUTION_STATUSES = {
  queued: { label: 'Queued', color: 'bg-slate-100 text-slate-700' },
  running: { label: 'Running', color: 'bg-blue-100 text-blue-700' },
  completed: { label: 'Completed', color: 'bg-green-100 text-green-700' },
  failed: { label: 'Failed', color: 'bg-red-100 text-red-700' },
  paused: { label: 'Paused', color: 'bg-yellow-100 text-yellow-700' },
  waiting: { label: 'Waiting', color: 'bg-purple-100 text-purple-700' },
  cancelled: { label: 'Cancelled', color: 'bg-slate-100 text-slate-700' },
};

// Condition operators
export const CONDITION_OPERATORS = [
  { value: 'equals', label: 'Equals' },
  { value: 'not_equals', label: 'Does not equal' },
  { value: 'contains', label: 'Contains' },
  { value: 'not_contains', label: 'Does not contain' },
  { value: 'greater_than', label: 'Greater than' },
  { value: 'less_than', label: 'Less than' },
  { value: 'is_empty', label: 'Is empty' },
  { value: 'is_not_empty', label: 'Is not empty' },
  { value: 'in_list', label: 'Is in list' },
  { value: 'starts_with', label: 'Starts with' },
  { value: 'ends_with', label: 'Ends with' },
];

// Common fields for conditions
export const CONDITION_FIELDS = [
  { value: 'job.workflow_stage', label: 'Job Stage' },
  { value: 'job.type', label: 'Job Type' },
  { value: 'job.total_value', label: 'Job Value' },
  { value: 'job.source', label: 'Lead Source' },
  { value: 'contact.tags', label: 'Contact Tags' },
  { value: 'contact.type', label: 'Contact Type' },
  { value: 'contact.state', label: 'State' },
  { value: 'contact.city', label: 'City' },
  { value: 'custom_fields.*', label: 'Custom Field' },
];

// Log type configurations
export const LOG_TYPES = {
  created: { label: 'Created', color: 'text-green-600' },
  updated: { label: 'Updated', color: 'text-blue-600' },
  activated: { label: 'Activated', color: 'text-green-600' },
  paused: { label: 'Paused', color: 'text-yellow-600' },
  archived: { label: 'Archived', color: 'text-red-600' },
  executed: { label: 'Executed', color: 'text-blue-600' },
  completed: { label: 'Completed', color: 'text-green-600' },
  failed: { label: 'Failed', color: 'text-red-600' },
  cancelled: { label: 'Cancelled', color: 'text-slate-600' },
  step_started: { label: 'Step Started', color: 'text-blue-600' },
  step_completed: { label: 'Step Completed', color: 'text-green-600' },
  step_failed: { label: 'Step Failed', color: 'text-red-600' },
  message_sent: { label: 'Message Sent', color: 'text-blue-600' },
  reply_received: { label: 'Reply Received', color: 'text-purple-600' },
  handoff_started: { label: 'Handoff Started', color: 'text-orange-600' },
  handoff_ended: { label: 'Handoff Ended', color: 'text-green-600' },
};

// Template variables for message templates
export const TEMPLATE_VARIABLES = [
  { value: '{{contact.first_name}}', label: 'Contact First Name' },
  { value: '{{contact.last_name}}', label: 'Contact Last Name' },
  { value: '{{contact.email}}', label: 'Contact Email' },
  { value: '{{contact.phone}}', label: 'Contact Phone' },
  { value: '{{job.customer_name}}', label: 'Job Customer Name' },
  { value: '{{job.workflow_stage}}', label: 'Job Stage' },
  { value: '{{job.address}}', label: 'Job Address' },
  { value: '{{job.total_value}}', label: 'Job Value' },
];
